import { render, staticRenderFns } from "./rhChatLog.vue?vue&type=template&id=71048787"
import script from "./rhChatLog.vue?vue&type=script&lang=js"
export * from "./rhChatLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports